import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';

import styles from './NavigationLinksGroup.styles';
import {INavigationLinksGroup} from '../types';

function NavigationLinksGroup({label, links}: INavigationLinksGroup): ReactElement {
  return (
    <ul className={cx(styles.componentWrapper(!label))}>
      {label && <li className={cx(styles.groupLabel)}>{label}</li>}
      {links.map((link) => (
        <li key={link.label} className={cx(styles.linkListItem, 'unstyledLink')}>
          <DynamicLink
            className={cx(styles.link, 'unstyledLink')}
            href={link.url}
            onClick={() => {
              track(segmentEvents.navigation.link, {
                name: link.label,
                url: link.url,
              });
            }}
          >
            <span className={cx(styles.linkLabel)}>{link.label}</span>
            {link.description && <Paragraph className={cx(styles.linkDescription)}>{link.description}</Paragraph>}
          </DynamicLink>
        </li>
      ))}
    </ul>
  );
}

export default NavigationLinksGroup;
